import { addDays, formatWeekdayNumber, relativeDayLabel, todayIn, toIso, utcToZoned, zonedToUtc } from '@lindeza/core';
import { useProfessional } from '@lindeza/core/hooks';
import { useState } from 'react';
import { Field, Sheet, TimeSelect } from '../../components/ui';

/** Botão +: marcar em qualquer dia e hora, inclusive fora dos horários abertos. */
export function PickTimeSheet({
  date: initialDate,
  defaultStart,
  onPick,
  onClose,
}: {
  date: string;
  defaultStart: string;
  onPick: (start: string) => void;
  onClose: () => void;
}) {
  const prof = useProfessional();
  const tz = prof?.timezone ?? 'America/Sao_Paulo';
  const today = todayIn(tz);
  const [date, setDate] = useState(initialDate);
  const [time, setTime] = useState(utcToZoned(defaultStart, tz).time);
  const days = Array.from({ length: 21 }, (_, i) => addDays(initialDate < today ? initialDate : today, i));
  return (
    <Sheet title="Marcar atendimento" sub={relativeDayLabel(date, today)} onClose={onClose}>
      <div className="stack stack--lg">
        <div className="ag-days ag-days--sheet">
          {days.map((d) => {
            const { weekday, day } = formatWeekdayNumber(d);
            return (
              <button key={d} className={d === today ? 'today' : undefined} aria-pressed={d === date} onClick={() => setDate(d)}>
                <span className="wd">{d === today ? 'hoje' : weekday}</span>
                <span className="d">{day}</span>
              </button>
            );
          })}
        </div>
        <Field label="Horário" htmlFor="pick-time">
          <TimeSelect id="pick-time" value={time} onChange={setTime} step={15} from={6 * 60} to={23 * 60} />
        </Field>
        <button className="btn btn--primary btn--lg btn--block" onClick={() => onPick(toIso(zonedToUtc(date, time, tz)))}>
          Escolher cliente
        </button>
      </div>
    </Sheet>
  );
}
